import { ISupportTreatment } from './SupportTreatment.types';

export const initialSupportTreatment : ISupportTreatment = {
  drug: "",
  dose: ""
}